module.exports = __webpack_public_path__ + "img/gas_meter_outlined.81014137.svg";